import { LineReveal, Overline } from "@/components/motion";
import { motion } from "framer-motion";
import { EASE } from "@/components/motion";

export default function PageHero({ overline, lines, intro, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden pt-40 pb-16 lg:pt-52 lg:pb-24">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.16]"
        style={{
          backgroundImage: "url(/assets/img/hero-bg.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-navy-950/60 via-navy-950/80 to-navy-950" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
        >
          <Overline>{overline}</Overline>
        </motion.div>
        <h1 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl">
          {lines.map((line, i) => (
            <LineReveal key={i} delay={0.25 + i * 0.14}>
              {line}
            </LineReveal>
          ))}
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
            className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
}
